import { makeStyles } from '~/UIKit/Style';
import { BORDER_COLOR, CHARCOAL_GREY, PRIMARY_BLUE, WHITE } from '~/Constants/Colors.constants';
import { FONT_SIZE_LARGE, FONT_SIZE_MEDIUM } from '~/Constants/UI.constants';

export const BookingListStyles = makeStyles((theme) => ({
  BookingListContainer: {
    minHeight: 450,
  },
  BookingListToolbar: {
    marginTop: 30,
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
      marginBottom: 10,
      position: 'sticky',
      top: 0,
      zIndex: 10,
      backgroundColor: WHITE,
    },
  },
  BookingListToolbarContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  ToolbarTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      padding: '9px 15px',
    },
  },
  BookingListSelect: {
    fontSize: FONT_SIZE_LARGE,
    color: PRIMARY_BLUE,
    fontWeight: 'bold',
  },
  buttonSelectEnable: {
    color: CHARCOAL_GREY,
    fontSize: 12,
  },
  emptyBookings: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 35,
  },
  emptyBookingsHeader: {
    fontWeight: 'bold',
    marginBottom: 30,
  },
  bookingDialog: {
    padding: '25px 50px',
    minHeight: 400,
  },
  bookingListBookingList: {
    padding: 0,
    paddingBottom: 30,
  },
  openBookingDialogButton: {
    fontSize: FONT_SIZE_MEDIUM,
    fontWeight: 'bold',
    lineHeight: '22px',
    color: PRIMARY_BLUE,
    height: 60,
    borderBottom: `1px solid ${BORDER_COLOR}`,
    [theme.breakpoints.down('md')]: {
      position: 'sticky',
      top: 0,
      zIndex: 10,
      backgroundColor: WHITE,
    },
  },
  openBookingDialogIcon: {
    display: 'flex',
    width: 30,
    height: 30,
    border: 'thin solid currentColor',
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 15,
  },
  loading: {
    display: 'flex',
    placeItems: 'center',
    placeContent: 'center',
    minHeight: '150px',
  },
}));
